import constate from 'constate'
import { PaginatedSearchStore, usePaginatedSearch } from 'scenes/Dashboard/components-next/PaginatedSearch'
import { PaginationOptions } from 'utils-next/types'

import {
  getApiSubspaceHandlers,
  Subspace,
  SUBSPACE_CACHE_STORE_ID,
  SubspaceListFilters,
} from '../../../../../../entities-next/subspace'

export type SubspaceListViewStore = {
  state: PaginatedSearchStore<Subspace, SubspaceListViewFilters>['state']
  actions: PaginatedSearchStore<Subspace, SubspaceListViewFilters>['actions']
}

export type SubspaceListViewFilters = SubspaceListFilters

function useSubspaceListViewInternalStore(): SubspaceListViewStore {
  const { state, actions: paginatedSearchActions } = usePaginatedSearch<Subspace, SubspaceListViewFilters>(
    SUBSPACE_CACHE_STORE_ID,
    subspaceListQuery,
    {
      initialFilters: {},
    }
  )
  return {
    state,
    actions: {
      ...paginatedSearchActions,
    },
  }
}

async function subspaceListQuery(_key: string, filters: SubspaceListViewFilters, paginationOptions: PaginationOptions) {
  const { apiGetSubspaceList } = getApiSubspaceHandlers()
  const query = await apiGetSubspaceList(filters, paginationOptions)
  return query.results
}

export const [SubspaceListViewProvider, useSubspaceListViewStore] = constate(useSubspaceListViewInternalStore)
